import request from "@/utils/request";
import { setUserProfile } from "@/utils/auth";

export function register(data) {
  return request({
    url: "/api/c/auth/register",
    method: "post",
    data,
  });
}

export function login(data) {
  return request({
    url: "/api/c/auth/login",
    method: "post",
    data,
  });
}

export function qywxLogin(data) {
  return request({
    url: "/api/c/auth/qywx-login",
    method: "post",
    data,
  });
}

export function getCurrentUser() {
  return request({
    url: "/api/c/auth/me",
    method: "get",
  }).then((res) => {
    // 接口返回成功后将用户信息持久化到 localStorage
    if (res && res.data) {
      setUserProfile(res.data);
    }
    return res;
  });
}

export function logout() {
  return request({
    url: "/api/c/auth/logout",
    method: "post",
  });
}

/**
 * 获取用户管理列表（子管理员以上权限）
 */
export function fetchManagedUsers(params) {
  return request({
    url: "/api/c/auth/userManageList",
    method: "get",
    params,
  });
}

/**
 * 调整用户积分
 */
export function updateUserPoints(data) {
  return request({
    url: "/api/c/auth/updateUser",
    method: "post",
    data,
  });
}

/**
 * 新增用户
 */
export function addUser(data) {
  return request({
    url: "/api/c/auth/addUser",
    method: "post",
    data,
  });
}

/**
 * 切换用户状态（禁用/启用）
 */
export function toggleUserStatus(data) {
  return request({
    url: "/api/c/auth/toggleUserStatus",
    method: "post",
    data,
  });
}

/**
 * 获取组织列表（用于新增用户选择）
 */
export function fetchGroupList() {
  return request({
    url: "/api/c/auth/homeUserAuth",
    method: "get",
  });
}

/**
 * 创建组长权限
 */
export function createGroupAuth(data) {
  return request({
    url: "/api/c/auth/createGroupAuth",
    method: "post",
    data,
  });
}

/**
 * 获取团队/公司列表
 */
export function fetchTeamList() {
  return request({
    url: "/api/c/auth/teamList",
    method: "get",
  });
}

/**
 * 获取用户列表（支持排除已有权限/已被分配的用户）
 */
export function fetchUserList(params) {
  return request({
    url: "/api/c/auth/userList",
    method: "get",
    params,
  });
}

/**
 * 更新组长权限
 */
export function updateGroupAuth(id, data) {
  return request({
    url: `/api/c/auth/updateGroupAuth/${id}`,
    method: "put",
    data,
  });
}

/**
 * 删除组长权限
 */
export function deleteGroupAuth(id) {
  return request({
    url: `/api/c/auth/deleteGroupAuth/${id}`,
    method: "delete",
  });
}

/**
 * 获取组长权限下的成员列表
 */
export function fetchGroupMembers(id) {
  return request({
    url: `/api/c/auth/groupMembers/${id}`,
    method: "get",
  });
}

/**
 * 查询当前用户是否已绑定 OA 企微
 */
export function getOaBindStatus() {
  return request({
    url: "/api/c/auth/oaBindStatus",
    method: "get",
  });
}

/**
 * 绑定 OA 企微账号
 */
export function bindOaUid(data) {
  return request({
    url: "/api/c/auth/bindOaUid",
    method: "post",
    data,
  });
}
